const getRootStateInitialValue = ({ content, data, locale }) => {
  var _a, _b, _c;
  const defaultValues = {};
  const initialState = ((_a = content == null ? void 0 : content.data) == null ? void 0 : _a.state) || {};
  (_c = (_b = content == null ? void 0 : content.data) == null ? void 0 : _b.inputs) == null ? void 0 : _c.forEach((input) => {
    if (input.name && input.defaultValue !== void 0)
      defaultValues[input.name] = input.defaultValue;
  });
  return {
    ...defaultValues,
    ...initialState,
    ...data,
    ...locale ? {
      locale
    } : {}
  };
};
const getContentInitialValue = ({ content, data }) => {
  return !content ? void 0 : {
    ...content,
    data: {
      ...content == null ? void 0 : content.data,
      ...data
    },
    meta: content == null ? void 0 : content.meta
  };
};
export {
  getContentInitialValue,
  getRootStateInitialValue
};
